import {
  DO_ROUTE,
  DO_ROUTE_PUSH,
  DO_IS_LOADING,
  DO_REQUEST_API,
  DO_PASO1,
  DO_PASO2,
  DO_PASO3,
  DO_PASO4,
  DO_PASO4_SUCCESS,
  DO_PASO_ERROR,
  DO_MENSAJE,
  DO_CLICK_TRACKING,
  DO_MOCK,
  DO_NOTIFICATION_TOAST,
  DO_NOTIFICATION_TOAST_RESET
} from "@/config/constants/action-types";

describe("Action-Types Constants Test", () => {
  it("should have the correct value for DO_ROUTE", () => {
    expect(DO_ROUTE).toEqual("DO_ROUTE");
  });

  it("should have the correct value for DO_ROUTE_PUSH", () => {
    expect(DO_ROUTE_PUSH).toEqual("DO_ROUTE_PUSH");
  });

  it("should have the correct value for DO_IS_LOADING", () => {
    expect(DO_IS_LOADING).toEqual("DO_IS_LOADING");
  });

  it("should have the correct value for DO_REQUEST_API", () => {
    expect(DO_REQUEST_API).toEqual("DO_REQUEST_API");
  });

  it("should have the correct value for DO_PASO1", () => {
    expect(DO_PASO1).toEqual("DO_PASO1");
  });

  it("should have the correct value for DO_PASO2", () => {
    expect(DO_PASO2).toEqual("DO_PASO2");
  });

  it("should have the correct value for DO_PASO3", () => {
    expect(DO_PASO3).toEqual("DO_PASO3");
  });

  it("should have the correct value for DO_PASO4", () => {
    expect(DO_PASO4).toEqual("DO_PASO4");
  });

  it("should have the correct value for DO_PASO4_SUCCESS", () => {
    expect(DO_PASO4_SUCCESS).toEqual("DO_PASO4_SUCCESS");
  });

  it("should have the correct value for DO_PASO_ERROR", () => {
    expect(DO_PASO_ERROR).toEqual("DO_PASO_ERROR");
  });

  it("should have the correct value for DO_MENSAJE", () => {
    expect(DO_MENSAJE).toEqual("DO_MENSAJE");
  });

  it("should have the correct value for DO_CLICK_TRACKING", () => {
    expect(DO_CLICK_TRACKING).toEqual("DO_CLICK_TRACKING");
  });

  it("should have the correct value for DO_MOCK", () => {
    expect(DO_MOCK).toEqual("DO_MOCK");
  });

  it("should have the correct value for DO_NOTIFICATION_TOAST", () => {
    expect(DO_NOTIFICATION_TOAST).toEqual("DO_NOTIFICATION_TOAST");
  });

  it("should have the correct value for DO_NOTIFICATION_TOAST_RESET", () => {
    expect(DO_NOTIFICATION_TOAST_RESET).toEqual("DO_NOTIFICATION_TOAST_RESET");
  });
});
